import { Helmet } from 'react-helmet';
import { defaultSEO } from 'config/seo';

export default function SEO({ title, description, image, type = 'website' }){
  const t = title || defaultSEO.title;
  const d = description || defaultSEO.description;
  const img = image || defaultSEO.image;

  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />

      {/* Open Graph */}
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:image" content={img} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={defaultSEO.locale} />
      <meta property="og:site_name" content={defaultSEO.siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={img} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content={defaultSEO.siteName} />
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
}